export const GET_SALES_EVENT_TYPES_REQUESTED =
  'GET_SALES_EVENT_TYPES_REQUESTED'
export const GET_SALES_EVENT_TYPES_SUCCEEDED =
  'GET_SALES_EVENT_TYPES_SUCCEEDED'
export const GET_SALES_EVENT_TYPES_FAILED =
  'GET_SALES_EVENT_TYPES_FAILED'

export const CREATE_SALES_EVENT_TYPE_REQUESTED =
  'CREATE_SALES_EVENT_TYPE_REQUESTED'
export const CREATE_SALES_EVENT_TYPE_SUCCEEDED =
  'CREATE_SALES_EVENT_TYPE_SUCCEEDED'
export const CREATE_SALES_EVENT_TYPE_FAILED =
  'CREATE_SALES_EVENT_TYPE_FAILED'

export const UPDATE_SALES_EVENT_TYPE_REQUESTED =
  'UPDATE_SALES_EVENT_TYPE_REQUESTED'
export const UPDATE_SALES_EVENT_TYPE_SUCCEEDED =
  'UPDATE_SALES_EVENT_TYPE_SUCCEEDED'
export const UPDATE_SALES_EVENT_TYPE_FAILED =
  'UPDATE_SALES_EVENT_TYPE_FAILED'

export const DELETE_SALES_EVENT_TYPE_REQUESTED =
  'DELETE_SALES_EVENT_TYPE_REQUESTED'
export const DELETE_SALES_EVENT_TYPE_SUCCEEDED =
  'DELETE_SALES_EVENT_TYPE_SUCCEEDED'
export const DELETE_SALES_EVENT_TYPE_FAILED =
  'DELETE_SALES_EVENT_TYPE_FAILED'
